(function ($, window) {
  "use strict";

  $(function () {
    Array.from(document.querySelectorAll(".js-qld__global-alert")).forEach(
      (alertSystem, index) => {
        const alertNo = index + 1;
        const alertHash = alertSystem.dataset.alertHash;
        const alertName = "alert-" + alertHash + "-viewed";
        const closeButton = alertSystem.querySelector(
          ".js-qld__global-alert__close"
        );
        let alertString = "";

        // Check if we've got an alert cookie.
        if (Cookies.get(alertName)) {
          alertString = `${Cookies.get(alertName)},`;
        }

        closeButton.addEventListener("click", (ev) => {
          ev.preventDefault();

          setTimeout(() => {
            alertSystem.parentNode.removeChild(alertSystem);
          }, 0);

          // Then add a cookie so we don't render it in WP anymore
          Cookies.set(alertName, `${alertString}${alertHash}`);
        });
      }
    );
  });
})(jQuery, window);
